import React from 'react';
import { FormattedMessage } from 'react-intl';
import { observer } from 'mobx-react-lite';
import PropTypes from 'prop-types';

import {
    AddressPropType,
    Question,
    QuestionAddress,
} from '@ratehub/base-ui';


function CoverageGroupQuestions({ values }) {
    return (
        <>
            {/* Company name */}
            <Question
                field={{
                    name: 'companyName',
                    type: 'string',
                    value: values.companyName,
                }}
                labelMessage={(
                    <FormattedMessage
                        id="InsLifeWizard.CoverageGroupQuestions.companyName"
                        defaultMessage="What is the name of your company?"
                    />
                )}
                placeholder={(
                    <FormattedMessage
                        id="InsLifeWizard.CoverageGroupQuestions.companyNamePlaceholder"
                        defaultMessage="Enter company"
                    />
                )}
                tooltipMessage={(
                    <FormattedMessage
                        id="InsLifeWizard.CoverageGroupQuestions.companyNameTooltip"
                        defaultMessage="Please provide us with your company's legal name."
                    />
                )}
            />

            {/* Business address */}
            <QuestionAddress
                name="businessAddress"
                value={values.businessAddress}
                labelMessage={(
                    <FormattedMessage
                        id="InsLifeWizard.CoverageGroupQuestions.businessAddress"
                        defaultMessage="What is your business address?"
                    />
                )}
                tooltipMessage={(
                    <FormattedMessage
                        id="InsLifeWizard.CoverageGroupQuestions.businessAddressTooltip"
                        defaultMessage="Please provide us with your company's primary business address. If you have more than one location, we only require the head office address at this time."
                    />
                )}
            />

            {/* Number of employees */}
            <Question
                field={{
                    name: 'numberOfEmployees',
                    type: 'integer',
                    value: values.numberOfEmployees,
                }}
                labelMessage={(
                    <FormattedMessage
                        id="InsLifeWizard.CoverageGroupQuestions.numberOfEmployees"
                        defaultMessage="How many employees does your company have?"
                    />
                )}
                placeholder={(
                    <FormattedMessage
                        id="InsLifeWizard.CoverageGroupQuestions.numberOfEmployeesPlaceholder"
                        defaultMessage="# Enter amount"
                    />
                )}
                tooltipMessage={(
                    <FormattedMessage
                        id="InsLifeWizard.CoverageGroupQuestions.numberOfEmployeesTooltip"
                        defaultMessage="This will help to calculate the size of your organization and your insurance needs. The larger your organization the more insurance coverage is required."
                    />
                )}
            />
        </>
    );
}

CoverageGroupQuestions.propTypes = {
    values: PropTypes.shape({
        companyName: PropTypes.string,
        businessAddress: AddressPropType,
        numberOfEmployees: PropTypes.number,
    }).isRequired,
};


export default observer(CoverageGroupQuestions);
